module.exports = __webpack_public_path__ + "static/dash-ba69eb8e0f1af1e599908750f2c1dd15.svg";